<template>
  <div class="text-black-dark text-center text-xl mt-6">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "StepInfo",
  props: {
    title: String
  }
}
</script>

<style scoped>

</style>
